import { render, staticRenderFns } from "./ArticleTagView.vue?vue&type=template&id=67ede4b4"
import script from "./ArticleTagView.vue?vue&type=script&lang=js"
export * from "./ArticleTagView.vue?vue&type=script&lang=js"
import style0 from "./ArticleTagView.vue?vue&type=style&index=0&id=67ede4b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports